// Mapping for NCMGroupIDs to Configuration Templates


const configMap = (ncmGroupId: number, hosttype?: string): string => {
  switch (ncmGroupId) {
    case 317696: // Default Coach
      return "1700"
      break;
    case 314975: // All Pylons 900
      return "900"
      break;
    case 527542: // All Pylons 980
      return "980"
      break;
    case 567989: // 1900 Streetcars
      return "1900streetcar"
      break;
    case 568005:
      return "1900coach"
      break;
    case 395429: // New VMS Group
      return "1700vms-2"
      break;
    case 633097: // Battery Bus
      return "1700bb"
      break;
    default:
      if (hosttype === "C") {
        return "1700";
      } else {
        return "900";
      }
      break;
  }
}

const templates = {
  "1700": require("./routerTemplates/ibr1700-no-vms.json"),
  "1700vms": require("./routerTemplates/ibr1700-vms.json"),
  "1700vms-2": require("./routerTemplates/ibr1700-vms-2.json"),
  "1700bb": require("./routerTemplates/ibr1700bb.json"),
  "1900streetcar": require("./routerTemplates/r1900-streetcar.json"),
  "1900coach": require("./routerTemplates/r1900-coach.json"),
  "900": require("./routerTemplates/ibr900.json"),
  "920": require("./routerTemplates/ibr920.json"),
  "980": require("./routerTemplates/ibr980.json")
};

const buildTemplate = (targetGroup: number, values = {}) => {
  const rawJSON = templates[configMap(targetGroup)];
  let jsonAsString = JSON.stringify(rawJSON);
  Object.keys(values).forEach((valueKey) => {
    jsonAsString = jsonAsString.replaceAll(`{{${valueKey}}}`, values[valueKey]);
  });

  return JSON.parse(jsonAsString);
};

export default buildTemplate;
